import { Fragment } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useTheme } from '@emotion/react'
import { SectionTitle } from 'chaoskit/src/components'

import GradientList from '../global/GradientList'

import KubernetesUI from './KubernetesUI'

import {
  ProductSection,
  ProductGridBlock,
  ProductGridBlockContent,
} from '~partials/product/UI'
import Data from '~components/Data'
import { ReactComponent as ReliabilitySVG } from '~media/product/kubernetes/reliability.svg'
import { ReactComponent as PreventDowntimeSVG } from '~media/product/kubernetes/prevent-downtime.svg'
import { ReactComponent as DevelopQuicklySVG } from '~media/product/kubernetes/develop-quickly.svg'

const KubernetesOverview = () => {
  const theme = useTheme()

  const {
    file: {
      childMdx: { frontmatter: pageData },
    },
  } = useStaticQuery(graphql`
    query KubernetesOverviewPageData {
      file(
        name: { eq: "product__kubernetes" }
        absolutePath: { regex: "/src/data/" }
      ) {
        childMdx {
          frontmatter {
            intro {
              heading
              blurb
            }
            reliability {
              heading
              items {
                blurb
              }
            }
            preventDowntime {
              heading
              items {
                blurb
              }
            }
            developQuickly {
              heading
              items {
                blurb
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Fragment>
      <ProductSection>
        <SectionTitle
          as="h2"
          title={<Data>{pageData.intro.heading}</Data>}
          sub={<Data>{pageData.intro.blurb}</Data>}
          css={{
            h2: {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },

            img: {
              maxHeight: '1em',
              marginLeft: theme.space.base,
            },
          }}
        />
        <KubernetesUI />
      </ProductSection>
      <ProductSection separator>
        <SectionTitle
          as="h2"
          title={<Data>{pageData.reliability.heading}</Data>}
        />
        <ProductGridBlock size="large">
          <ReliabilitySVG
            css={{
              width: '100%',
              maxWidth: 400,
              margin: '0 auto',

              [theme.mq.medium]: {
                maxWidth: 550,
                gridColumn: '1 / span 6',
                gridRow: 1,
              },
            }}
          />

          <ProductGridBlockContent>
            <GradientList items={pageData.reliability.items} />
          </ProductGridBlockContent>
        </ProductGridBlock>
      </ProductSection>
      <ProductSection separator>
        <SectionTitle
          as="h2"
          title={<Data>{pageData.preventDowntime.heading}</Data>}
        />
        <ProductGridBlock size="large">
          <PreventDowntimeSVG
            css={{
              width: '100%',
              margin: '0 auto',
              maxWidth: 400,

              [theme.mq.medium]: {
                maxWidth: 550,
                gridColumn: '7 / span 6',
                gridRow: 1,
              },
            }}
          />
          <ProductGridBlockContent
            css={{
              [theme.mq.medium]: {
                gridColumn: '1 / span 6',
              },
            }}
          >
            <GradientList items={pageData.preventDowntime.items} />
          </ProductGridBlockContent>
        </ProductGridBlock>
      </ProductSection>
      <ProductSection separator>
        <SectionTitle
          as="h2"
          title={<Data>{pageData.developQuickly.heading}</Data>}
        />
        <ProductGridBlock size="large">
          <DevelopQuicklySVG
            css={{
              width: '100%',
              maxWidth: 400,
              margin: '0 auto',

              [theme.mq.medium]: {
                maxWidth: 550,
                gridColumn: '1 / span 6',
                gridRow: 1,
              },
            }}
          />
          <ProductGridBlockContent>
            <GradientList items={pageData.developQuickly.items} />
          </ProductGridBlockContent>
        </ProductGridBlock>
      </ProductSection>
    </Fragment>
  )
}

export default KubernetesOverview
